import { render } from "./ScoutReportsFiltersForm.vue?vue&type=template&id=bc54fa54"
import script from "./ScoutReportsFiltersForm.vue?vue&type=script&lang=js"
export * from "./ScoutReportsFiltersForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__